module.exports = __webpack_public_path__ + "static/media/YB5F01_2.fdff4427.jpg";